import Resources from "shared/actions/resourcesActions";

class FileImportsResource extends Resources {
  constructor(dispatch) {
    super(dispatch, "file_imports", `/api/v1/file_imports`);
  }
}

export default FileImportsResource;
